import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import { toast } from 'react-toastify';
import axios from 'axios';

const EditDeliveryPoint = ({ show, onClose, deliveryPoint, onUpdated }) => {

    const [deliveryName, setDeliveryName] = useState('');
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [branches, setBranches] = useState([]);
    const [areas, setAreas] = useState([]);
    const [selectedAreas, setSelectedAreas] = useState([]);
    const [errors, setErrors] = useState({});
    const [areasLoaded, setAreasLoaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        if (show) {
            axios.get(`${baseURL}/managebranch`)
                .then((res) => {
                    const branchOptions = res.data.data.data.map(b => ({
                        value: b.sno,
                        label: b.branch_name
                    }));
                    setBranches(branchOptions);
                })
                .catch(err => {
                    console.error('Error loading branches:', err);
                });
        }
    }, [show]);

    // Populate initial values
    useEffect(() => {
        console.log(deliveryPoint);
        if (deliveryPoint) {
            // console.log('DeliveryPoint received in EditDeliveryPoint:', deliveryPoint);
            setDeliveryName(deliveryPoint.delivery_point);
            setSelectedBranch({
                value: deliveryPoint.branch_data?.sno,
                label: deliveryPoint.branch_data?.branch_name
            });
            setSelectedAreas(deliveryPoint.area_name?.map(a => a.sno) || []);
        }
    }, [deliveryPoint]);

    // Fetch areas when branch changes
    // useEffect(() => {
    //     if (selectedBranch?.value) {
    //         axios.get(`${baseURL}/managearea`, {
    //             params: { branch_name: selectedBranch.value }
    //         }).then(res => {
    //             console.log('Areas API response:', res.data.data);
    //             setAreas(Array.isArray(res.data.data) ? res.data.data : []);
    //         }).catch(err => {
    //             console.error('Error loading areas:', err);
    //         });
    //     }
    // }, [selectedBranch]);
    useEffect(() => {
        if (selectedBranch?.value) {
            setAreasLoaded(false);
            axios.get(`${baseURL}/managearea`, {
                params: { branch_id: selectedBranch.value }
            })
                .then(res => {
                    console.log("Areas API response:", res.data);
                    // Use this based on what API returns
                    // For example, if res.data.data is the array of areas:
                    const areaList = Array.isArray(res.data.data?.data) ? res.data.data.data : [];
                    // const filteredAreas = areaList.filter(area => area.branch_name === selectedBranch.value);
                    const filteredAreas = areaList.filter(area =>
                        area.branch_name === selectedBranch.value && area.status === 0
                    );
                    setAreas(filteredAreas);
                    setAreasLoaded(true);
                })
                .catch(err => {
                    console.error('Error loading areas:', err);
                    setAreas([]);
                    setAreasLoaded(true);
                });
        }
    }, [selectedBranch]);
    // useEffect(() => {
    //     if (selectedBranch?.value) {
    //         setAreasLoaded(false);
    //         axios.get(`${baseURL}/managearea`, {
    //             params: { branch_name: selectedBranch.value }
    //         }).then(res => {
    //             // setAreas(res.data.data || []);
    //             setAreas(Array.isArray(res.data.data?.data) ? res.data.data.data : []);
    //             setAreasLoaded(true);
    //         }).catch(err => {
    //             console.error('Error loading areas:', err);
    //             setAreas([]);
    //             setAreasLoaded(true);
    //         });
    //     }
    // }, [selectedBranch]);

    useEffect(() => {
        if (areas.length > 0 && deliveryPoint?.area_name) {
            // Map only areas that are present in the fetched areas list
            const validSelectedAreas = deliveryPoint.area_name
                .map(a => a.sno)
                .filter(sno => areas.some(area => area.sno === sno));
            setSelectedAreas(validSelectedAreas);
        }
    }, [areas, deliveryPoint]);

    useEffect(() => {
        console.log('deliveryPoint.area_name:', deliveryPoint?.area_name);
    }, [deliveryPoint]);

    useEffect(() => {
        console.log('fetched areas:', areas);
    }, [areas]);

    useEffect(() => {
        console.log("Branches loaded:", branches);
    }, [branches]);

    useEffect(() => {
        console.log("Selected branch:", selectedBranch);
    }, [selectedBranch]);

    useEffect(() => {
        console.log("Areas loaded:", areas);
    }, [areas]);

    useEffect(() => {
        console.log("Selected Areas:", selectedAreas);
    }, [selectedAreas]);

    const handleAreaChange = (areaId) => {
        const id = Number(areaId);
        setSelectedAreas(prev =>
            prev.includes(id) ? prev.filter(a => a !== id) : [...prev, id]
        );
    };

    const handleUpdate = async () => {
        const newErrors = {};
        if (!deliveryName.trim()) newErrors.deliveryName = 'This Field is required.';
        if (!selectedBranch) newErrors.branch = 'This Field is required.';
        if (selectedAreas.length === 0) newErrors.areas = 'Atleast Choose One.';
        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        const selectedAreaObjects = selectedAreas.map(id => {
            const area = areas.find(a => a.sno === id);
            return area ? { name: area.area_name, sno: area.sno } : null;
        });

        try {
            setLoading(true);
            await axios.put(`${baseURL}/managedeliverypoint/${deliveryPoint.sno}`, {
                branch_name: selectedBranch.value,
                delivery_point: deliveryName.trim(),
                area_name: selectedAreaObjects
            });
            toast.success("Delivery Point Updated successfully!");
            onUpdated();
            onClose();
            setLoading(false);
        } catch (error) {
            console.error('Error updating delivery point:', error);
            setLoading(false);
            // alert('Failed to update delivery point.');
        }
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Delivery Point</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Delivery Point<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Delivery Point" maxLength={50} value={deliveryName}
                                onChange={(e) => {
                                    if (e.target.value.length <= 50) {
                                        setDeliveryName(e.target.value);
                                    }
                                }} />
                            {errors.deliveryName && <small className="text-danger">{errors.deliveryName}</small>}
                        </div>
                        {/* <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Branch<span className="required">*</span></label>
                            <Select placeholder='Select Branch Name'
                                value={selectedBranch}
                                onChange={setSelectedBranch}
                                options={branches}
                            />
                            {errors.branch && <small className="text-danger">{errors.branch}</small>}
                        </div> */}
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Select Area<span className="required">*</span></label>
                            <div className='row mb-2'>
                                {Array.isArray(areas) && areas.length > 0 ? (
                                    areas.map(area => (
                                        <div className="col-lg-6" key={area.sno}>
                                            <div className='form-check-inline mt-3'>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value={area.sno}
                                                    checked={selectedAreas.includes(area.sno)}
                                                    onChange={() => handleAreaChange(area.sno)}
                                                />
                                                <label className="fs-7 text-black mb-0 font-w500">{area.area_name}</label>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p>No areas found.</p>
                                )}
                            </div>
                            {errors.areas && <small className="text-danger">{errors.areas}</small>}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button type="submit" className={`btn btn-sm btn-primary ${loading ? 'disabled' : ''}`} onClick={handleUpdate}>{loading ? 'Loading...' : 'Update Delivery Point'} <i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditDeliveryPoint;
